export const ACTION_GET_DYNAMIC_BUNDLE_ELEMENT = '/Catalog/GetDynamicBundleElements';